import type { ReactNode } from 'react';

export const symbol_home_health: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M430-390v50q0 20.83 14.62 35.42Q459.24-290 480.12-290q20.88 0 35.38-14.58Q530-319.17 530-340v-50h50q20.83 0 35.42-14.62Q630-419.24 630-440.12q0-20.88-14.58-35.38Q600.83-490 580-490h-50v-50q0-20.83-14.62-35.42Q500.76-590 479.88-590q-20.88 0-35.38 14.58Q430-560.83 430-540v50h-50q-20.83 0-35.42 14.62Q330-460.76 330-439.88q0 20.88 14.58 35.38Q359.17-390 380-390h50ZM220-120q-24.75 0-42.37-17.63Q160-155.25 160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q15.68-12 35.84-12Q500-825 516-813l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220Zm0-60h520v-394L480-763 220-574v394Zm260-292Z"
		/>
	</svg>
);
